import { Component, OnInit, OnDestroy } from '@angular/core';
import { Company, Owner, User, UserType, Icons } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OwnerEditComponent } from '../owner-edit/owner-edit.component';

@Component({
	selector: 'app-owner-view',
	templateUrl: './owner-view.component.html',
	styleUrls: ['./owner-view.component.scss']
})
export class OwnerViewComponent implements OnInit, OnDestroy {

	company: Company;
	loading: boolean = false;
	owner: Owner;
	tab: string;

	keys: string[];
	canvalidate: boolean;
	breadcrumb: Breadcrumb;
	error: boolean;

	constructor(
		private ownerService: CrudService<Owner>,
		private companyService: CrudService<Company>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private modalService: NgbModal) {

		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				this.canvalidate = ((data as User).utype === UserType.admin);
			}
		});
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
			this.tab = params['tab'];
		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.ownerService.getEntity(Owner, 'owner', id).subscribe(owner => {
			this.owner = owner;
			if (this.owner) {
				this.error = false;
				this.createKeys();
				this.companyService.getEntity(Company, 'company', this.owner.companyid).subscribe(company => {
					this.company = company;
					this.loading = false;
					this.setBreadcrumb();
				});
			} else {
				this.error = true;
				this.loading = false;
			}

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.owner'));
			this.owner = undefined;
			this.loading = false;
			this.error = true;
		});
	}



	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.company.name, url: '/company/view/' + this.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
		];
		this.breadcrumb.addData('docinvalid', !this.owner.docvalid);
		this.breadcrumb.title = { title: 'labels.view-owner', param: this.owner.fullname, icon: Icons.OWNER, icontooltip: 'labels.company' };
	}

	createKeys(): void {
		this.keys = Object.keys(this.owner);
		const exclude = ['fname', 'lname', 'birthdate', 'insdate', 'moddate', 'companyid', 'id', 'name'];
		this.keys = this.keys.filter(k => this.owner[k] && exclude.indexOf(k) < 0);
	}


	attachmentsChanged(): void {
		if (this.owner && this.owner.id) {
			this.ownerService.getEntity(Owner, 'owner', this.owner.id).subscribe(owner => {
				this.owner.docvalid = owner.docvalid;
				this.breadcrumb.addData('docinvalid', !this.owner.docvalid);
			}, ({ error }) => {

			});
		}
	}

	edit() {
		const modal = this.modalService.open(OwnerEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.companyid = this.owner.companyid;
		modal.componentInstance.load(this.owner.id);

		modal.result.then((newItem: Owner) => {
			this.load(this.owner.id);
		}).catch(() => { });
	}

}
